import styled from "@emotion/styled";
import { formInputTheme } from "../../textinput/styled/formInputTheme";
import { TypeRampV2 } from "../../typography";
export const SelectButtonText = styled(TypeRampV2)`
    min-width: 0;
    text-align: start;
    color: ${_ref => {
  let {
    themeMode
  } = _ref;
  return `var(--sds--form--color--value, ${formInputTheme.textColor.rest(themeMode)})`;
}};
`;
//# sourceMappingURL=SelectButtonText.js.map